import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import SideBar from './components/sidebar';

import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { MsalProvider, MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from './config';
import { SnackbarProvider } from 'material-ui-snackbar-provider';
import ErrorIcon from '@material-ui/icons/Error';
import { useTranslation } from 'react-i18next';
import { Box, Backdrop, Hidden, LinearProgress, Typography } from '@material-ui/core';
import { Imagebank } from './components/imagebank';
import { Header } from './components/header';
import mtStyles from './styles/mtStyles';

import { ToastContainer } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';

import {
  SMSView,
  EmailView,
  PrintView,
  DashboardView,
  CampaignListView,
  CampaignView,
  TemplateListView } from './views';

import { useSelector } from 'react-redux';

const App = ({ pca }) => {
  const isLoadingChains = useSelector(state => state.doris.isLoadingChains);
  const isLoadingSites = useSelector(state => state.doris.isLoadingSites);
  const isLoadingError = useSelector(state => state.doris.error);

  const isLoading = isLoadingChains || isLoadingSites;

  const { t } = useTranslation();
  const classes = mtStyles();

  return (
    <>
      <MsalProvider instance={pca}>
        <Backdrop
          style={{ backgroundColor: 'white', zIndex: 5000, flexDirection: 'column' }}
          open={isLoading}>
          {isLoadingError &&
              <>
                <ErrorIcon color="error" fontSize="large" /><Typography color="error" component="div" variant="bold">Oops! KAPA service is unavailable</Typography>
              </>
          }
          {!isLoadingError &&
              <>
                <Typography color="primary" component="div">Initializing app...</Typography>
                <LinearProgress color="primary" style={{ width: '200px' }} />
              </>
          }
        </Backdrop>
        <MsalAuthenticationTemplate
          interactionType={InteractionType.Redirect}
          authenticationRequest={loginRequest}>
          <Box className={classes.problem} height={1}>
            <CssBaseline />
            <ToastContainer
              position="top-right"
              autoClose={3000}
              hideProgressBar
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
            <SnackbarProvider SnackbarProps={{ autoHideDuration: 4000 }}>
              <BrowserRouter>
                <Hidden mdDown={true}><SideBar /></Hidden>
                <Box ml={5} mr={5} flexGrow="1" bgcolor="#fcf8fd">
                  <Header />
                  <Switch>
                    <Route exact path="/"><Redirect to="/dashboard" /></Route>
                    <Route exact path="/dashboard" component={DashboardView} />
                    <Route exact path="/imagebank">
                      <Redirect to="/imagebank/print" />
                    </Route>
                    <Route exact path="/imagebank/add" component={Imagebank} />
                    <Route path="/imagebank/:imageType" component={Imagebank} />
                    <Route exact path="/campaigns" component={CampaignListView} />
                    <Route exact path="/campaigns/:id" component={CampaignView} />
                    <Route exact path="/templates/sms/add" component={SMSView} />
                    <Route exact path="/templates/sms/:id" component={SMSView} />
                    <Route exact path="/templates/email/add" component={EmailView} />
                    <Route exact path="/templates/email/:id" component={EmailView} />
                    <Route exact path="/templates/print/add" component={PrintView} />
                    <Route exact path="/templates/print/:id(\d+)" component={PrintView} />
                    <Route exact path={['/templates', '/templates/:tab']} component={TemplateListView} />
                    <Route exact path="/not-found" render={() => <h1>{t('not-found')}</h1>} />
                    <Route render={() => <h1>{t('not-found')}</h1>} />
                  </Switch>
                </Box>
              </BrowserRouter>
            </SnackbarProvider>
          </Box>

        </MsalAuthenticationTemplate>
      </MsalProvider>
    </>
  );
};


export default App;
